// @flow

import React, { Component } from 'react';

import { connect } from 'react-redux';
import { activities as fetch, audit } from 'app/redux/modules/dwelling';

import i18n from 'app/common/i18n';
import Button from 'app/common/button';
import Loading from 'app/common/Loading';

import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Timeline from 'app/activity/timeline';

type Props = {
  open?: boolean,
  label: string,
  icon: any,
  uuid: string,
  fullScreen: boolean,
  onClose?: () => void,
  audit: Function,
  fetch: Function
};

type State = {
  open: boolean,
  loading: boolean,
  data: Object | null,
  reason: string
};

@connect(() => ({}), { fetch, audit })
@i18n
class ActivitiesDialog extends Component<Props, State> {
  i18n: Function;

  constructor(props: Props) {
    super(props);
    this.state = {
      open: false,
      loading: false,
      data: null,
      reason: ''
    };
  }

  componentDidMount() {
    if (this.props.open === true && !this.state.open) {
      this.handleOpen();
    }
  }

  handleOpen = () => {
    this.setState({ open: true, loading: true });
    this.props
      .fetch(this.props.uuid)
      .then((result) => {
        this.setState({ loading: false, data: result.payload });
      })
      .catch((err) => {
        if (__DEV__) {
          console.error(err);
        }
        this.setState({ loading: false, data: null });
      });
  };

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    } else {
      this.setState({ open: false, loading: false, data: null });
    }
  };

  handleChange = (ev: { currentTarget: { name: string, value: string } }) => {
    const { name, value } = ev.currentTarget;
    this.setState({ [name]: value });
  };

  handleSubmit = () => {
    const { reason } = this.state;
    this.props.audit(this.props.uuid, reason).then(() => {
      this.setState({ reason: '' });
      this.handleOpen();
    });
  };

  renderDialog() {
    const { fullScreen } = this.props;
    const { data, loading, open, reason } = this.state;

    return (
      <Dialog
        fullWidth
        fullScreen={fullScreen}
        open={open}
        onClose={this.handleClose}
      >
        <DialogTitle>{this.props.i18n('Activity log')}</DialogTitle>
        <DialogContent>
          <TextField
            name="reason"
            value={reason}
            helperText={this.props.i18n('Add comment/notes')}
            multiline
            fullWidth
            onChange={this.handleChange}
          />
          {reason && !loading ? (
            <Button
              style={{ float: 'right' }}
              primary
              label={this.props.i18n('Save')}
              onClick={this.handleSubmit}
            />
          ) : null}
          <div style={{ clear: 'both', height: '1em', display: 'block' }} />
          {loading ? (
            <Loading />
          ) : data && data.length ? (
            <Timeline data={data} />
          ) : (
            'Something went wrong...'
          )}
        </DialogContent>
        <DialogActions>
          <Button
            flat
            label={this.props.i18n('Close')}
            onClick={this.handleClose}
          />
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const { label, icon } = this.props;
    return this.props.open === true ? (
      this.renderDialog()
    ) : (
      <div style={{ display: 'inline-block' }}>
        <Button flat label={label} icon={icon} onClick={this.handleOpen} />
        {this.renderDialog()}
      </div>
    );
  }
}

function ActivitiesDialogWithMobileDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return <ActivitiesDialog {...props} fullScreen={fullScreen} />;
}

export default ActivitiesDialogWithMobileDialog;